<template lang="pug">
  v-form(@submit.prevent="submit")
    h2(class="title-32px fw-700") {{ $t('Edit payment') }}
    ValidationObserver(ref="form" tag="div" class="mt-8")
      ValidationProvider(
        v-slot="{ errors }"
        :name="wrapQuotesProviderName($t('Description'))"
        rules="required"
      )
        v-textarea(
          v-model="form.description"
          :error-messages="errors"
          :label="$t('Description')"
          :height="150"
          filled
          hide-details="auto"
        )
      v-checkbox(
        v-model="form.resetStatus"
        :label="$t('Process payment again')"
        hide-details="auto"
      )
      v-checkbox(
        v-if="form.resetStatus"
        v-model="form.skipValidations"
        :label="$t('Skip payment validation')"
        hide-details="auto"
      )
    v-btn(
      type="submit"
      class="main-button mt-8"
      :loading="loading"
    ) {{ $t('Edit') }}
</template>

<script>
import validate from '~/mixins/validation/validate'
import { PAYMENT_STATUSES } from '~/modules/billing/constants/common'
import successSnackbar from '~/modules/snackbar/mixins/successSnackbar'

export default {
  name: 'PaymentEditForm',
  mixins: [validate, successSnackbar],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    payment: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loading: false,
    form: {
      description: null,
      resetStatus: false,
      skipValidations: false
    }
  }),
  mounted() {
    this.form.description = this._.get(this.payment, 'description', null)
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }
      try {
        this.loading = true
        await this.$store.dispatch('payments/update', {
          id: this.payment.id,
          payload: {
            description: this.form.description,
            status: this.form.resetStatus ? PAYMENT_STATUSES.new : this.payment.status,
            skipValidations: !!this.form.skipValidations
          }
        })
        this.successSnackbar.open({
          text: this.$t('Payment has edited')
        })
        this.closeModal()
      } catch (error) {
        this.$handlers.error(error, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
